<script>
    import hotspotLogo from "../assets/img/hotspot.png";
    import visaLogo from "../assets/img/visa.png";
    import mastercardLogo from "../assets/img/mastercard.png";
    import nedbankLogo from "../assets/img/nedbank.png";
    import standardBankLogo from "../assets/img/standardbank.png";
    import absaLogo from "../assets/img/absa.png";
    import fnbLogo from "../assets/img/fnb.png";
    import capitecLogo from "../assets/img/capitec.png";
    import back from "../assets/img/back.png";

    export let store;

    //this can be improved if we could set defaults with fetch, I had a skill issue here
    const baseURL = import.meta.env.VITE_BASE_URL;
    const portalURL = import.meta.env.VITE_BASE_PORTAL_URL;

    const hotspotBundles = [
        { id: 5, name: "1 Day", price: 5 },
        { id: 2, name: "3 Day", price: 10 },
        { id: 3, name: "7 Day", price: 30 },
        { id: 4, name: "30 Day", price: 120 },
    ];

    async function redirectToPayment(productID) {
        try {
            let response = await fetch(`${portalURL}card/payment/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    hotspot_product: productID,
                    mac_address: store.macAddress,
                    cellphone: store.cellphone,
                }),
            });

            if (response.ok) {
                let data = await response.json();
                window.location = data.checkout_url;
            }
        } catch (error) {
            // handle error (log, show notification, etc.)
            console.error("Error:", error);
        }
    }

    function backButton() {
        store.setState("ACCOUNT");
    }
</script>

<div class="w-full px-2 py-8">
    <div class="w-full mx-4">
        <button class="flex flex-row" on:click={backButton}>
            <img class="w-3" src={back} alt="Back button" />
            <div class="w-1"></div>
            <p class="text-[#5b95c8] text-md font-bold mx-2">Back</p>
        </button>
    </div>

    <div class="h-2"></div>

    <div class="mx-auto w-2/5">
        <img src={hotspotLogo} alt="TooMuchWifi hotspot logo" />
    </div>

    <div class="justify-center w-full">
        <div class="mx-auto">
            <p class="font-medium mb-2 py-4 text-center text-xl">
                Purchase Hotspot Package
            </p>
        </div>

        <div class="h-1/6"></div>

        <div class="flex flex-wrap justify-center items-end space-y-4 mb-4">
            {#each hotspotBundles as product}
                <!-- svelte-ignore a11y_click_events_have_key_events -->
                <!-- svelte-ignore a11y_no_static_element_interactions -->
                <div class="flex flex-col mx-2 w-5/12 max-w-60">
                    <div class="bg-black py-2 flex-col rounded-t-2xl">
                        <h2 class="font-medium mx-4 text-2xl text-white">
                            {product.name}
                        </h2>
                        <div class="h-2"></div>
                        <div class="bg-yellow-500 h-0.5 mx-2 mt-auto"></div>
                    </div>

                    <div class="bg-black flex-row h-85 relative">
                        <div class="h-14"></div>
                        <h2
                            class="text-2xl lg:text-4xl text-white font-bold ml-4 uppercase top-0 left-0 absolute"
                        >
                            R{product.price}
                        </h2>
                        <div
                            class="absolute border-[#1899d1] bottom-0 right-0 bg-white h-10 w-7/12 rounded-tl-full border-t-8 border-l-8"
                        ></div>
                        <div class="bg-[#1899d1] h-2"></div>
                    </div>

                    <div class="bg-white rounded-b-2xl py-4 shadow-xl">
                        <div class="mx-auto w-fit">
                            <button
                                on:click={() => redirectToPayment(product.id)}
                                class="bg-[#1899d1] text-white px-4 py-1 text-center text-xs font-semibold rounded-sm"
                            >
                                Buy Now
                            </button>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</div>
